import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { CalendarHeart } from "@phosphor-icons/react";

import EmptyAppointment from "assets/empty_appointment.png";
import { ModuleContainer } from "../styles";
import ModuleHeader from "../ModuleHeader";

const EmptyNextAppointment = () => {
  return (
    <Paper
      component="section"
      elevation={2}
      sx={ModuleContainer}
      data-testid="empty-next-appointment"
    >
      <ModuleHeader Icon={CalendarHeart} title="Next appointment" />
      <Stack direction="row" spacing={7} mt={7} alignItems="center">
        <Box>
          <img src={EmptyAppointment} width={223} alt="Empty next appointment" />
        </Box>
        <Box>
          <Typography component="p" variant="body1" color="text.secondary">
            It&apos;s quiet at the moment. Head over to your schedule to manage appointments.
          </Typography>

          <Button
            variant="outlined"
            color="inherit"
            size="large"
            sx={{ mt: 7 }}
            href="/clinician-schedule"
          >
            Go to my schedule
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

export default EmptyNextAppointment;
